var map = {
	"./cruise/Bedroom vessels_V.3.png": 41,
	"./cruise/Control room_V.4.png": 42,
	"./cruise/Engine Room_V.4.png": 43,
	"./cruise/Foye Cruise_V.2.png": 44,
	"./cruise/Large conference room_V.3.png": 45,
	"./cruise/criuse_overview.png": 46,
	"./data-center/Kitchen_V.4.png": 47,
	"./data-center/Outdoor scene.png": 48,
	"./data-center/control-rooms-v4.jpg": 49,
	"./data-center/data_center_overview_v2.png": 50,
	"./data-center/data_hall_v1.jpg": 51,
	"./data-center/data_hall_v7.jpg": 52,
	"./data-center/electrical-switching-room-v3.jpg": 53,
	"./data-center/emergency-power-supply-rooms-v4.jpg": 54,
	"./data-center/office_v5.jpg": 55,
	"./data-center/transformers_chillers_generators_v3.jpg": 56,
	"./e-house/Data hall.png": 57,
	"./e-house/E-House Overview_V.2.png": 58,
	"./e-house/Electrical switches room.png": 59,
	"./e-house/Emergency power supply rooms.png": 60,
	"./e-house/Outdoor scene.png": 61,
	"./e-house/Transformers_Chillers_Generators.png": 62,
	"./hospital/foyer-v4.png": 63,
	"./hospital/hospital.png": 64,
	"./hospital/lab-v4.png": 65,
	"./hospital/nurses-station-v5.png": 66,
	"./hospital/patient-room-v5.png": 67,
	"./hospital/surgery-v5.png": 68,
	"./hotel/Bedroom_V.3.png": 69,
	"./hotel/Control room_V.4.png": 70,
	"./hotel/Foyer_V.4.png": 71,
	"./hotel/Kitchen_V.4.png": 72,
	"./hotel/Large conference room_V.3.png": 73,
	"./hotel/Overview_V.2.png": 74,
	"./hotel/jpg files - OLD/Bedroom_V.3.jpg": 75,
	"./hotel/jpg files - OLD/Control room_V.4.jpg": 76,
	"./hotel/jpg files - OLD/Foyer_V.4.jpg": 77,
	"./hotel/jpg files - OLD/Kitchen_V.4.jpg": 78,
	"./hotel/jpg files - OLD/Large conference room_V.3.jpg": 79,
	"./hotel/jpg files - OLD/Overview_V.2.jpg": 80,
	"./lng/Bedroom vessels_V.3.png": 81,
	"./lng/Engine Room_V.4.png": 82,
	"./lng/Hull_V.5.png": 83,
	"./lng/LNG.png": 84,
	"./lng/Re-liquefaction plant_V.3.png": 85,
	"./wind-farm/AC_converter.PNG": 86,
	"./wind-farm/HDVC Converter.png": 87,
	"./wind-farm/Windfarm nacelle_V.8.png": 88,
	"./wind-farm/Windfarm tower_V.3.png": 89,
	"./wind-farm/overview.png": 90
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18;